import { numberToTwoDigitString } from 'common/helpers';
import { Flex } from 'components';
import './style.scss';

function TravelTimeBlock(props: { travelTimeSeconds?: number | null }) {
  let timeBlock: React.ReactNode;

  if (props.travelTimeSeconds != null) {
    const hours = Math.floor(props.travelTimeSeconds / 60 / 60);
    const minutes = Math.floor((props.travelTimeSeconds - hours * 60 * 60) / 60);

    timeBlock = (
      <Flex
        gap={5}
        justifyContent='center'
      >
        <span>{numberToTwoDigitString(hours)}</span>
        <span>:</span>
        <span>{numberToTwoDigitString(minutes)}</span>
      </Flex>
    );
  } else {
    timeBlock = <div>N/A</div>;
  }

  return (
    <Flex
      direction='column'
      justifyContent='center'
    >
      <div className='travel-time-anHa'>Время в пути</div>
      {timeBlock}
    </Flex>
  );
}

export default TravelTimeBlock;
